import { classNames } from '@allurion/ui';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';

import styles from './Loader.module.scss';

type Props = {
  isLoading: boolean;
  type?: string;
  color?: string;
  height?: string | number;
  width?: string | number;
  cover?: boolean;
  className?: string;
};

export function Loader({
  isLoading = false,
  type = 'spokes',
  color = '#FFF8F0',
  height = '100%',
  width = '100%',
  cover = true,
  className = '',
}: Props) {
  const [localIsLoading, setLocalIsLoading] = useState(isLoading);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isLoading) {
      setLocalIsLoading(true);
    } else {
      timeout = setTimeout(() => {
        setLocalIsLoading(false);
      }, 500);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isLoading]);

  const loader = (
    <ReactLoading
      type={type as any}
      color={color}
      height={height}
      width={width}
      className={className}
    />
  );

  if (!isLoading) {
    return null;
  }

  if (cover) {
    return (
      <div className={classNames(styles.container, localIsLoading && styles.isLoading)}>
        <div className={styles.loaderWrapper}>{loader}</div>
      </div>
    );
  }

  return localIsLoading ? loader : null;
}
